import React, { useState } from "react";
import { MenuItem, Select, TextField, TextareaAutosize, ToggleButton, ToggleButtonGroup } from "@mui/material";
import AiSubjectAutocomplete from "./AiSubjectAutocomplete";

export default function AiSubjectChooser({ language, setLanguage, url, setUrl, selectedSubject, setSelectedSubject, post, setPost, setContinueButton }) {
  const [value, setValue] = useState("blogUrl");
  const [urlValidation, setUrlValidation] = useState("");

  const handleTabChange = (event, newValue) => {
    if (newValue !== null) {
      setValue(newValue);
    }
  };

  return (
    <div>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleTabChange}
        fullWidth
        sx={{
          paddingBottom: 1,
          marginBottom: 2,
        }}
      >
        <ToggleButton value="blogUrl" sx={{ textTransform: "none" }}>
          URL
        </ToggleButton>
        <ToggleButton value="enterTopic" sx={{ textTransform: "none" }}>
          Topic
        </ToggleButton>
        <ToggleButton value="enterPost" sx={{ textTransform: "none" }}>
          Text
        </ToggleButton>
      </ToggleButtonGroup>

      <div>
        {value === "blogUrl" && (
          <div>
            <TextField label="Paste a URL" fullWidth value={url} onChange={(e) => {
              setUrlValidation("");
              setContinueButton(false);

              setUrl(e.target.value);
              const u = e.target.value;
              if (u.length === 0) return;
              
              if (!u.startsWith("http")) {
                setUrlValidation("Please enter a valid URL");
                return;
              } else if (u.startsWith("http") && !u.startsWith("http://") && !u.startsWith("https://")) {
                setUrlValidation("Please include http:// or https:// in the URL");
                return;
              } else {
                const d = getDomainInfo(u);
                if (!d) {
                  setUrlValidation("Please enter a valid URL");
                  return;
                }
                else if (d.domain === "linkedin.com" || d.domain === "facebook.com" || d.domain === "instagram.com" || d.domain === "twitter.com" || d.domain === "youtube.com") {
                  setUrlValidation(d.domain + " is not supported. Please enter a different URL.");
                  return;
                }
              }
              setContinueButton(true);
            }} />
            {urlValidation.length > 0 && (
              <div style={{
                fontSize: "0.75rem",
                color: "rgba(0, 0, 0, 0.54)",
                marginTop: "0.5rem",
                marginLeft: "0.5rem",
              }}>{urlValidation}</div>
            )}
          </div>
        )}
        {value === "enterTopic" && (
         
            <div>
              <div style={{ 
                display: "flex", 
                flexDirection: "row",
                gap: "1rem"
              }}>
                <TextField fullWidth label="Describe your topic"  value={selectedSubject} onChange={(e) => {
                  setSelectedSubject(e.target.value);
                  setContinueButton(e.target.value.length > 0);
                }} style={{ flex: 2 }}/>
                
              </div>
              <div style={{
                fontSize: "0.75rem",
                color: "rgba(0, 0, 0, 0.54)",
                marginTop: "0.5rem",
                marginLeft: "0.5rem",
              }}>
                Example: Tips for Baking a Cake
              </div>
            </div>
        )}
        {value === "enterPost" && (
          <div>
              <TextareaAutosize minRows={5} maxRows={10} placeholder="Enter your post here" style={{ width: "100%" }} value={post} onChange={(e) => {
                if (e.target.value.length > 10) {
                  setContinueButton(true);
                }
                setPost(e.target.value);
              }} />
          </div>
            
        )}
      </div>
    </div>
  );
}


function getDomainInfo(url) {
  try {
    const parsedUrl = new URL(url);
    return {
        protocol: parsedUrl.protocol,
        hostname: parsedUrl.hostname,
        domain: parsedUrl.hostname.split('.').slice(-2).join('.'), // Example for second-level domain
        subdomain: parsedUrl.hostname.split('.').length > 2 ? parsedUrl.hostname.split('.').slice(0, -2).join('.') : '',
        port: parsedUrl.port || 'default',
        path: parsedUrl.pathname,
    };
  } catch (error) {
    return null;
  }
}
